import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Button from "../../components/Button";
import Icon from "../../components/Icon";
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter,
} from "../../components/Modal";
import { closeModal, sendEmailModule } from "../../actions";
import styles from "../../components/Modal.module.css";

export class SendEmailModuleModal extends Component {
  constructor(props) {
    super(props);
    this.send = this.send.bind(this);
    this.setEmail = this.setEmail.bind(this);
    this.handleType = this.handleType.bind(this);
    this.state = {
      sending: false,
      email: props.emailAddress,
    };
    this.nameRef = createRef();
  }

  componentDidMount() {
    if (this.nameRef?.current) {
      this.nameRef.current.focus();
    }
  }

  handleType(e) {
    this.setState({
      email: e.target.value,
    });
  }

  send() {
    const { accountId, id } = this.props;

    if (this.state.sending) {
      return false;
    }

    this.setState({
      sending: true,
    });

    this.props
      .sendEmailModule(accountId, id, this.state.email)
      .then(this.props.closeModal);
  }

  setEmail(e) {
    e.stopPropagation();
    e.preventDefault();

    this.setState({ email: "dm-test@feed-london.com" });
  }

  render() {
    return (
      <Modal>
        <ModalHeader>Send Email Module</ModalHeader>
        <ModalContent>
          <form onSubmit={this.send}>
            <div className={styles.flex}>
              <label>Email Address</label>
              <input
                value={this.state.email}
                onChange={this.handleType}
                ref={this.nameRef}
                autoFocus
              />
            </div>
            <div className={styles.flex}>
              <label></label>
              <a className={styles.emailButton} onClick={this.setEmail}>
                dm-test@feed-london.com
              </a>
            </div>
          </form>
        </ModalContent>
        <ModalFooter>
          <Button type="link" onClick={this.props.closeModal}>
            Cancel
          </Button>
          {this.state.sending ? (
            <Button color="greyed">
              <Icon icon="refresh" spin="true" /> Sending...
            </Button>
          ) : (
            <Button onClick={this.send}>Send</Button>
          )}
        </ModalFooter>
      </Modal>
    );
  }
}

SendEmailModuleModal.propTypes = {
  sendEmailModule: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  key: PropTypes.string,
  accountId: PropTypes.string.isRequired,
  emailAddress: PropTypes.string.isRequired,
};

// Connect state data
function mapStateToProps(state) {
  const { params } = state.modal;
  const { accountId, id } = params;
  const emailAddress = state.auth.identity.username;

  return {
    emailAddress,
    accountId,
    id,
  };
}

// Connect actions
export default connect(mapStateToProps, {
  closeModal,
  sendEmailModule,
})(SendEmailModuleModal);
